<template>
    <div v-if="model && form">
        <rkm-area
            title="Filtros"
            type="fieldset"
            no-margin-top
        >
            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col>
                        <rkm-form-date-picker
                            range
                            v-model="model.periodo"
                            start-label="Data inicial"
                            end-label="Data final"
                            :range-inline="false"
                            :start-validations="validations.periodo"
                            :end-validations="validations.periodo"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            label="Município"
                            :options="form.municipios"
                            v-model="model.municipioId"
                            value-field="id"
                            text-field="nome"
                            show-default-option
                            default-option-text="TODOS"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            label="Tipo"
                            :options="form.tipos"
                            v-model="model.tipoId"
                            value-field="id"
                            text-field="nome"
                            show-default-option
                            default-option-text="TODOS"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-select
                            label="Unidade"
                            :options="form.unidades"
                            v-model="model.unidadeId"
                            value-field="id"
                            text-field="nomeFantasia"
                            show-default-option
                            default-option-text="TODAS"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            label="Local de atendimento"
                            :options="form.infraestruturas"
                            v-model="model.infraestruturaId"
                            value-field="id"
                            text-field="nome"
                            show-default-option
                            default-option-text="TODAS"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            label="Especialidade"
                            :options="form.especialidades"
                            v-model="model.especialidadeId"
                            value-field="id"
                            text-field="nome"
                            show-default-option
                            default-option-text="TODAS"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-select
                            label="Origem"
                            :options="form.origens"
                            v-model="model.origemId"
                            value-field="id"
                            text-field="nome"
                            show-default-option
                            default-option-text="TODAS"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            label="Médico"
                            :options="form.usuarios"
                            v-model="model.usuarioId"
                            value-field="id"
                            text-field="nome"
                            show-default-option
                            default-option-text="TODOS"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            label="Status"
                            :options="form.status"
                            v-model="model.statusId"
                            value-field="id"
                            text-field="nome"
                            show-default-option
                            default-option-text="TODOS"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-button
                            :label="false"
                            color="primary"
                            @click="list"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="clearForm"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            no-margin-top
            title="Resultado"
            v-if="Array.isArray(consultas)"
        >
            <template v-slot:trailing>
                <rkm-dropdown
                    class="mr-2"
                    color="primary"
                    cols="1"
                    menu-class="auto-scroll"
                    no-caret
                    small
                    title="Colunas"
                    v-rkm-tooltip.hover
                >
                    <template v-slot:button-content>
                        <rkm-icon icon="columns" />
                    </template>

                    <rkm-form-checkbox
                        @change="selectAll"
                        class="mx-2"
                        v-model="selectedAll"
                    >
                        Todas
                    </rkm-form-checkbox>

                    <rkm-form-checkbox-group
                        :options="optionalColumns"
                        class="mx-2"
                        stacked
                        text-field="label"
                        v-model="selectedCols"
                        value-field="key"
                    />
                </rkm-dropdown>

                <rkm-button
                    title="Imprimir"
                    color="info"
                    @click="print"
                    small
                    :disabled="consultas.length < 1"
                >
                    <rkm-icon icon="print"/>
                </rkm-button>

                <rkm-button
                    :disabled="consultas.length < 1"
                    @click="exportTo"
                    color="info"
                    small
                    title="Exportar"
                >
                    <rkm-icon icon="file-export" />
                </rkm-button>
            </template>

            <rkm-table
                :fields="fields"
                :items="consultas"
                :hide-filters="true"
                :hide-pagination="true"
                sort-by="data"
            >
                <template v-slot:cell(data)="row">
                    {{ row.value | formatDate }}
                </template>
            </rkm-table>
        </rkm-area>

        <rkm-area
            title="Totais"
            type="fieldset"
            no-margin-top
            v-if="Array.isArray(consultas)"
        >
            <rkm-row>
                <rkm-col>
                    Faltou
                    <rkm-alert color="secondary">
                        <b>{{ model.total.faltou }}</b>
                    </rkm-alert>
                </rkm-col>

                <rkm-col>
                    Realizado
                    <rkm-alert color="secondary">
                        <b>{{ model.total.realizado }}</b>
                    </rkm-alert>
                </rkm-col>

                <rkm-col>
                    Reagendado pelo paciente
                    <rkm-alert color="secondary">
                        <b>{{ model.total.reagendadoPaciente }}</b>
                    </rkm-alert>
                </rkm-col>

                <rkm-col>
                    Reagendado pelo médico
                    <rkm-alert color="secondary">
                        <b>{{ model.total.reagendadoMedico }}</b>
                    </rkm-alert>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    Agendado
                    <rkm-alert color="secondary">
                        <b>{{ model.total.agendado }}</b>
                    </rkm-alert>
                </rkm-col>

                <rkm-col>
                    Cancelado pelo paciente
                    <rkm-alert color="secondary">
                        <b>{{ model.total.canceladoPaciente }}</b>
                    </rkm-alert>
                </rkm-col>

                <rkm-col>
                    Falta médica
                    <rkm-alert color="secondary">
                        <b>{{ model.total.faltaMedica }}</b>
                    </rkm-alert>
                </rkm-col>
    
                <rkm-col>
                    Cancelado pelo médico
                    <rkm-alert color="secondary">
                        <b>{{ model.total.canceladoMedico }}</b>
                    </rkm-alert>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="3">
                    Origem agendada
                    <rkm-alert color="secondary">
                        <b>{{ model.total.origemAgendado }}</b>
                    </rkm-alert>
                </rkm-col>

                <rkm-col cols="3">
                    Origem demanda espontânea
                    <rkm-alert color="secondary">
                        <b>{{ model.total.demandaEspontanea }}</b>
                    </rkm-alert>
                </rkm-col>
    
                <rkm-col cols="3">
                    Total geral
                    <rkm-alert color="secondary">
                        <b>{{ model.total.geral }}</b>
                    </rkm-alert>
                </rkm-col>
            </rkm-row>
        </rkm-area>
    </div>
</template>

<script>
import { repository, error, data, object, stringCase, file } from '@/mixins'
import format from '@/filters/formats'
import { mapActions } from 'vuex'
import moment from 'moment'

export default {
    filters: {
        formatDate: format.formatDate
    },
    created() {
        this.repositories = {
            relatorioEstatisticoConsulta: this.getConectaSusRepository('ambulatorio.relatorioEstatisticoConsulta'),
            exportacao: this.getConectaSusRepository('exportacao.ambulatorio'),
            impressao: this.getConectaSusRepository('impressao.ambulatorio')
        }
        this.load()
    },
    data() {
        return {
            model: null,
            form: null,
            consultas: null,
            selectedCols: [],
            columns: [
                {
                    key: 'data',
                    label: 'Data',
                    sortable: true,
                    fixed: true

                },
                {
                    key: 'municipio',
                    label: 'Município',
                    sortable: true
                },
                {
                    key: 'unidade',
                    label: 'Unidade',
                    sortable: true
                },
                {
                    key: 'infraestrutura',
                    label: 'Local de atendimento',
                    sortable: true,
                    fixed: true
                },
                {
                    key: 'especialidade',
                    label: 'Especialidade',
                    sortable: true,
                    fixed: true
                },
                {
                    key: 'usuario',
                    label: 'Médico',
                    sortable: true,
                    fixed: true
                },
                {
                    key: 'tipo',
                    label: 'Tipo',
                    sortable: true
                },
                {
                    key: 'status',
                    label: 'Status',
                    sortable: true,
                    fixed: true
                },
                {
                    key: 'origem',
                    label: 'Origem',
                    sortable: true,
                    fixed: true
                },
                {
                    key: 'quantidade',
                    label: 'Quantidade',
                    fixed: true
                },

            ]
        }
    },
    computed: {
        validations() {
            return {
                periodo: { required: true },
            }
        },
        fields() {
            return this.columns.filter(c => (c.fixed || false) || this.selectedCols.includes(c.key))
        },
        optionalColumns() {
            return this.columns.filter(c => !(c.fixed || false))
        },
        selectedAll: {
            set: function() {
                return this.selectedCols.length == 8
            },
            get: function(isAllSelected) {
                return isAllSelected
            }
        },
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()
            this.repositories.relatorioEstatisticoConsulta.index()
                .then(({ data }) => {
                    this.model = data.model
                    this.form = data.form
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getMunicipios() {
            this.setLoading()
            this.repositories.relatorioEstatisticoConsulta.getMunicipios({
                data_inicial: moment(this.model.periodo.start).format('YYYY-MM-DD'),
                data_final: moment(this.model.periodo.end).format('YYYY-MM-DD'),
                origem_id: this.model.origemId
            })
                .then(({ data }) => {
                    this.form.municipios = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getUnidades() {
            this.setLoading()
            this.repositories.relatorioEstatisticoConsulta.getUnidades({
                data_inicial: moment(this.model.periodo.start).format('YYYY-MM-DD'),
                data_final: moment(this.model.periodo.end).format('YYYY-MM-DD'),
                municipio_id: this.model.municipioId,
                tipo_id: this.model.tipoId,
                origem_id: this.model.origemId
            })
                .then(({ data }) => {
                    this.form.unidades = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getInfraestruturas() {
            this.setLoading()
            this.repositories.relatorioEstatisticoConsulta.getInfraestruturas({
                data_inicial: moment(this.model.periodo.start).format('YYYY-MM-DD'),
                data_final: moment(this.model.periodo.end).format('YYYY-MM-DD'),
                municipio_id: this.model.municipioId,
                tipo_id: this.model.tipoId,
                unidade_id: this.model.unidadeId,
                origem_id: this.model.origemId
            })
                .then(({ data }) => {
                    this.form.infraestruturas = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getEspecialidades() {
            this.setLoading()
            this.repositories.relatorioEstatisticoConsulta.getEspecialidades({
                data_inicial: moment(this.model.periodo.start).format('YYYY-MM-DD'),
                data_final: moment(this.model.periodo.end).format('YYYY-MM-DD'),
                municipio_id: this.model.municipioId,
                tipo_id: this.model.tipoId,
                unidade_id: this.model.unidadeId,
                infraestrutura_id: this.model.infraestruturaId,
                origem_id: this.model.origemId
            })
                .then(({ data }) => {
                    this.form.especialidades = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getUsuarios() {
            this.setLoading()
            this.repositories.relatorioEstatisticoConsulta.getUsuarios({
                data_inicial: moment(this.model.periodo.start).format('YYYY-MM-DD'),
                data_final: moment(this.model.periodo.end).format('YYYY-MM-DD'),
                municipio_id: this.model.municipioId,
                tipo_id: this.model.tipoId,
                unidade_id: this.model.unidadeId,
                infraestrutura_id: this.model.infraestruturaId,
                especialidade_id: this.model.especialidadeId,
                origem_id: this.model.origemId
            })
                .then(({ data }) => {
                    this.form.usuarios = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        list() {
            this.$refs.Form.validate()
                .then(valid => {
                    if(!valid) return
                    this.setLoading()
                    this.repositories.relatorioEstatisticoConsulta.list({
                        data_inicial: moment(this.model.periodo.start).format('YYYY-MM-DD'),
                        data_final: moment(this.model.periodo.end).format('YYYY-MM-DD'),
                        municipio_id: this.model.municipioId,
                        tipo_id: this.model.tipoId,
                        unidade_id: this.model.unidadeId,
                        infraestrutura_id: this.model.infraestruturaId,
                        especialidade_id: this.model.especialidadeId,
                        origem_id: this.model.origemId,
                        usuario_id: this.model.usuarioId,
                        status_id: this.model.statusId
                    })
                        .then(({ data }) => {
                            this.consultas = data.resultado
                            this.model.total = data.totais
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        print() {
            this.setLoading()
            this.repositories.impressao.relatorioEstatisticoConsulta({
                data_inicial: moment(this.model.periodo.start).format('YYYY-MM-DD'),
                data_final: moment(this.model.periodo.end).format('YYYY-MM-DD'),
                municipio_id: this.model.municipioId,
                tipo_id: this.model.tipoId,
                unidade_id: this.model.unidadeId,
                infraestrutura_id: this.model.infraestruturaId,
                especialidade_id: this.model.especialidadeId,
                origem_id: this.model.origemId,
                usuario_id: this.model.usuarioId,
                status_id: this.model.statusId,
                colunas: this.fields.map(f => {
                    return {
                        key: this.camelToSnake(f.key),
                        label: f.label,
                        class: f.class
                    }
                })
            })
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        exportTo() {
            this.setLoading()
            this.repositories.exportacao.relatorioEstatisticoConsulta({
                data_inicial: moment(this.model.periodo.start).format('YYYY-MM-DD'),
                data_final: moment(this.model.periodo.end).format('YYYY-MM-DD'),
                municipio_id: this.model.municipioId,
                tipo_id: this.model.tipoId,
                unidade_id: this.model.unidadeId,
                infraestrutura_id: this.model.infraestruturaId,
                especialidade_id: this.model.especialidadeId,
                origem_id: this.model.origemId,
                usuario_id: this.model.usuarioId,
                status_id: this.model.statusId,
                colunas: this.fields.map(f => {
                    return {
                        key: this.camelToSnake(f.key),
                        label: f.label,
                        class: f.class
                    }
                })
            })
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        clearForm() {
            this.model.periodo.start = null
            this.model.periodo.end = null
            this.model.municipioId = null
            this.model.tipoId = null
            this.model.unidadeId = null
            this.model.especialidadeId = null
            this.model.origemId = null
            this.model.usuarioId = null
            this.model.statusId = null
            this.consultas = null
            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        selectAll(selected) {
            this.selectedCols = selected ? this.columns.map(c => c.key) : []
        }
    },
    watch: {
        'model.periodo.start': function() {
            if(this.model.periodo.start && this.model.periodo.end) {
                this.getMunicipios()
                this.getUnidades()
                this.getEspecialidades()
                this.getUsuarios()
            }
        },
        'model.periodo.end': function() {
            if(this.model.periodo.start && this.model.periodo.end) {
                this.getMunicipios()
                this.getUnidades()
                this.getEspecialidades()
                this.getUsuarios()
            }
        },
        'model.municipioId': function() {
            if(this.model.periodo.start && this.model.periodo.end && this.model.municipioId) {
                this.getUnidades()
                this.getEspecialidades()
                this.getUsuarios()
            }
        },
        'model.tipoId': function() {
            if(this.model.periodo.start && this.model.periodo.end && this.model.tipo_id) {
                this.getUnidades()
                this.getEspecialidades()
                this.getUsuarios()
            }
        },
        'model.unidadeId': function() {
            if(this.model.periodo.start && this.model.periodo.end && this.model.unidadeId) {
                this.getInfraestruturas()
            }
        },
        'model.infraestruturaId': function() {
            if(this.model.periodo.start && this.model.periodo.end &&this.model.infraestruturaId) {
                this.getEspecialidades()
                this.getUsuarios()
            }
        },
        'model.especialidadeId': function() {
            if(this.model.periodo.start && this.model.periodo.end && this.model.especialidadeId) {
                this.getUsuarios()
            }
        },
        'model.origemId': function() {
            if(this.model.periodo.start && this.model.periodo.end && this.model.origemId) {
                this.getUsuarios()
            }
        },
    },
    mixins: [repository, error, data, object, stringCase, file],
}
</script>